import { createAction, props } from '@ngrx/store';
import { userPermission } from 'src/app/shared/interfaces/userPermission.interface';

export interface UserPermissionsRequest {
  userGuid?: string | null;
  tennantCode?: string | null;
}

export const loadUserPermissionsByLoggedUser = createAction(
  '[User Permissions] Load By Logged User',
  props<{ request: UserPermissionsRequest }>(),
);

export const loadUserPermissionsSuccess = createAction(
  '[User Permissions] Load Success',
  props<{ response: userPermission[] }>(),
);

export const loadUserPermissionsSuccessByKey = createAction(
  '[User Permissions] Load Success By Key',
  props<{ key: string; response: userPermission[] }>(),
);

export const loadUserPermissionsFailure = createAction('[User Permissions] Load Failure', props<{ error: any }>());
